import { SET_BREADCRUMB } from '@/constants/store-mutation-types'

export default {
  install(Vue) {
    Vue.mixin({
      computed: {
        $parentRoute() {
          const matchedRoutes = this.$route.matched
          return matchedRoutes.length > 2
            ? matchedRoutes[matchedRoutes.length - 2]
            : matchedRoutes[0]
        },
        $permissionScope() {
          const parentRouteIndex = this.$route.matched.findIndex(
            (route) => route.name === this.$parentRoute.name
          )

          if (parentRouteIndex >= 0) {
            const routePermissions = this.$route.matched.reduce(
              (permissions, route, index) => {
                if (index <= parentRouteIndex && route.meta && route.meta.auth)
                  permissions.push(route.meta.auth)

                return permissions
              },
              []
            )

            return routePermissions.join('.')
          }

          return ''
        },
        $sectionTitle() {
          return this.$parentRoute
            ? this.$parentRoute.meta.sectionTitle
              ? this.$t(this.$parentRoute.meta.sectionTitle)
              : this.$parentRoute.meta.label
              ? this.$t(`nav.${this.$parentRoute.meta.label}`)
              : null
            : null
        }
      },
      methods: {
        $setBreadcrumb(items = []) {
          this.$store.commit(SET_BREADCRUMB, items)
        },
        $getQueryFilter(q, remove = false) {
          let found = false
          let query = Object.assign({}, this.$route.query)
          let result = null

          if (Object.keys(query).length) {
            if (query[q]) {
              result = query[q]
              delete query[q]
              found = true
            }

            if (remove && found) this.$router.replace({ query })
          }

          return result
        },
        $successfulCreate(
          title,
          backRoute = './',
          templateKey = 'shared._hasBeenCreatedSuccessfully'
        ) {
          this.$showSuccess(this.$t(templateKey, { title }))

          if (backRoute)
            if (backRoute === '_back') this.$router.back()
            else this.$router.replace(backRoute)
        },
        $successfulEdit(
          title,
          backRoute = '../',
          templateKey = 'shared._hasBeenEditedSuccessfully'
        ) {
          this.$showSuccess(this.$t(templateKey, { title }))

          if (backRoute)
            if (backRoute === '_back') this.$router.back()
            else this.$router.replace(backRoute)
        },
        $getChangeStateConfirmText(
          title,
          enable,
          templateKey = 'shared.areYouSureYouWantTo__'
        ) {
          return this.$t(templateKey, {
            action: this.$t(`shared.${enable ? 'disabling' : 'enabling'}`),
            title
          })
        },
        $isEmpty(value) {
          return typeof value === 'object' && value
            ? !Object.keys(value).length
            : value == null || value.length === 0
        },
        $validateAll(focus = true) {
          return this.$validator.validateAll().then((proceed) => {
            if (!proceed) {
              if (focus) {
                this.focusToInvalidInput()
              }
            }
            return proceed
          })
        },
        $preSubmit(refs = null, focus = true) {
          const validationArray = [this.$validateAll(false)]

          if (refs) {
            refs = typeof refs === 'string' ? [refs] : refs
            refs.forEach((ref) => {
              const arrayOfRefs = Array.isArray(this.$refs[ref])
                ? this.$refs[ref]
                : [this.$refs[ref]]
              arrayOfRefs.forEach((ref) => {
                if (ref) validationArray.push(ref.$validateAll(false))
              })
            })
          }

          return Promise.all(validationArray).then((results) => {
            const proceed = results.every((result) => result)
            if (!proceed && focus) this.focusToInvalidInput()
            return proceed
          })
        },
        $hasPermission(
          permissionName,
          namespace = null,
          permissionList = null
        ) {
          permissionList =
            permissionList || this.$store.state.$account
              ? this.$store.state.$permissions
              : []
          namespace = namespace || this.$permissionScope

          //  ! TODO: should return true when full migration is done
          if (!namespace || !permissionName) return true

          permissionName = `${namespace}.${permissionName}`

          return !!permissionList.find(
            (permission) => permission === permissionName
          )
        },
        focusToInvalidInput() {
          const firstInvalidInput =
            document.getElementsByClassName('invalid-input')[0]
          if (firstInvalidInput) {
            // handle tab change if component include tabs
            const tabContainer = this.$refs['tab-container']
            if (tabContainer) {
              if (
                firstInvalidInput.attributes['tab-index'] &&
                Number(firstInvalidInput.attributes['tab-index'].value) !==
                  tabContainer.currentTab
              ) {
                console.log(firstInvalidInput.attributes['tab-index'].value)
                tabContainer.currentTab = Number(
                  firstInvalidInput.attributes['tab-index'].value
                )
              }
            }

            this.$nextTick(() => {
              firstInvalidInput.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
              firstInvalidInput.focus({ preventScroll: true })
            })
          }
        },
        $isObject(val) {
          return val !== null && typeof val === 'object' && !Array.isArray(val)
        },
        $randomNumber() {
          return Math.floor(Math.random() * 100000)
        }
      }
    })
  }
}
